/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PieChart = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83" }],
    ["path", { d: "M22 12A10 10 0 0 0 12 2v10z" }]
  ]
];

export { PieChart as default };
//# sourceMappingURL=pie-chart.js.map
